



































import Vue from "vue";
import { computed } from "@vue/composition-api";
import GaIcon from "../../card-items/GaIcon.vue";
import { useGenAiPalette } from "../../data/design";
import { Level, SEVERITY_LABEL } from "./event-view";

export default Vue.extend({
  components: { GaIcon },
  props: {
    level: { type: String, default: "none" },
    size: { type: String, default: "md" },
    variant: { type: String, default: "solid" },
    show_label: { type: Boolean, default: false },
  },
  setup(props) {
    const T = useGenAiPalette();
    const level = computed(() => (props.level || "none") as Level);
    const tone = computed(() => T.value.severity[level.value]);
    const label = computed(() =>
      level.value === "none" ? SEVERITY_LABEL.none : `${SEVERITY_LABEL[level.value]} risk`
    );
    const box = computed(() => {
      const sm = props.size === "sm";
      const base = {
        width: sm ? "20px" : "24px",
        height: sm ? "20px" : "24px",
        borderRadius: sm ? "4px" : "6px",
      };
      return props.variant === "soft"
        ? {
            ...base,
            background: tone.value.chipBg,
            color: tone.value.chipText,
            border: "1px solid " + tone.value.dot + "40",
          }
        : { ...base, background: tone.value.dot, color: "#FFFFFF" };
    });
    return { T, tone, label, box };
  },
});
